/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. See .browserslistrc for the specific browser targets.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * NOTE: IE polyfills have been removed as the application now targets only modern browsers.
 * See .browserslistrc for the specific browser targets:
 * - Chrome >= 138
 * - Edge >= 142
 * - Safari >= 18
 * - Firefox >= 147
 * - iOS >= 18
 *
 * All targeted browsers natively support ES2022+ features, so core-js polyfills are not needed.
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

(window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
(window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';



/***************************************************************************************************
 * APPLICATION IMPORTS
 */
